import "@arco-design/web-react/es/Table/style";
import _Table from "@arco-design/web-react/es/Table";
import React from 'react';
import GuideLayout from '../GuideLayout';
import MermaidChart from '../MermaidChart';
import styles from '../style/index.module.less';
const fullFlowChart = `graph TD
    A["📩 收到询价/竞价邀请"] --> B["查看物料需求\\n& 下载图纸"]
    B --> C["在线报价/竞价"]
    C --> D{"采购方评审"}
    D -->|"中标/选中"| E["收到采购订单"]
    D -->|"未选中"| F["等待下次机会"]
    E --> G{"是否同意\\n价格和交期?"}
    G -->|"同意"| H["订单确认"]
    G -->|"要协商"| I["磋商\\n提出你的价格/交期"]
    I --> G
    H --> J["下载合同\\n& 签署回传"]
    J --> K["备货生产"]
    K --> L["创建发货单\\n& 发货"]
    L --> M["采购方收货\\n& 品检"]
    M --> N{"品检结果"}
    N -->|"合格"| O["入库完成"]
    N -->|"不合格"| P["退货处理"]
    O --> Q["📋 对账确认"]
    Q --> R["💰 收款结算"]

    E -.->|"交期前3天"| S["📅 交期反馈"]
    S -->|"正常"| K
    S -->|"延迟"| T["反馈新交期"]
    T --> K

    style A fill:#E3F2FD,stroke:#2196F3
    style C fill:#FFF3E0,stroke:#FF9800
    style L fill:#E8F5E9,stroke:#4CAF50
    style P fill:#FFEBEE,stroke:#F44336
    style R fill:#F3E5F5,stroke:#9C27B0
    style S fill:#FFF9C4,stroke:#FFC107`;
const tipsColumns = [{
  title: '环节',
  dataIndex: 'step'
}, {
  title: '要点',
  dataIndex: 'tip'
}];
const tipsData = [{
  step: '报价',
  tip: '报价前务必查看图纸确认规格型号；阶梯价格要合理设置最小起订量'
}, {
  step: '订单确认',
  tip: '收到订单后及时确认，如有异议进入磋商阶段协商价格和交期'
}, {
  step: '交期反馈',
  tip: '交货前 3 天系统推送确认请求，及时反馈正常或延迟；延迟请主动给新交期'
}, {
  step: '发货',
  tip: '基于已确认订单创建发货单，填写实际发货数量，打印随货单据'
}, {
  step: '图纸',
  tip: '每次生产前确认图纸版本为最新，系统记录阅图版本号'
}, {
  step: '对账',
  tip: '核对对账单中的收货数量、金额是否与实际一致'
}, {
  step: '费用',
  tip: '及时确认采购方发起的费用项；如有额外费用主动创建'
}, {
  step: '收款',
  tip: '关注付款单状态，确认到账后核对余额'
}];
const financeFlowChart = `graph LR
    A["采购方收货入库"] --> B["系统生成对账单"]
    B --> C["你确认对账单"]
    C --> D["系统派生付款单"]
    D --> E["采购方审批"]
    E --> F["财务确认 & 付款"]
    F --> G["你查看余额\n确认到账"]`;
const expenseFlowChart = `graph LR
    A["发货/退货\n产生额外费用"] --> B{"谁发起?"}
    B -->|"采购方"| C["采购方创建费用项"]
    C --> D["你确认费用"]
    B -->|"你（供应商）"| E["你创建费用项"]
    E --> F["采购方确认费用"]
    D --> G["纳入对账单结算"]
    F --> G`;
const expenseExamplesColumns = [{
  title: '场景',
  dataIndex: 'scene'
}, {
  title: '发起方',
  dataIndex: 'initiator'
}, {
  title: '金额方向',
  dataIndex: 'direction'
}, {
  title: '说明',
  dataIndex: 'desc'
}];
const expenseExamplesData = [{
  scene: '发货补充运费',
  initiator: '采购方',
  direction: '正（+）给你',
  desc: '订单价不含运费，额外补运费给你'
}, {
  scene: '退货罚款',
  initiator: '采购方',
  direction: '负（−）扣你',
  desc: '质量问题导致退货，扣款处罚'
}, {
  scene: '加急生产费',
  initiator: '你（供应商）',
  direction: '正（+）给你',
  desc: '因加急产生额外费用，向采购方收取'
}, {
  scene: '包装补偿',
  initiator: '你（供应商）',
  direction: '正（+）给你',
  desc: '特殊包装要求的额外费用'
}];
const sections = [{
  id: 'full-flow',
  label: '供应商全流程'
}, {
  id: 'tips',
  label: '操作要点'
}, {
  id: 'finance',
  label: '对账与收款'
}, {
  id: 'expense',
  label: '费用项'
}];
export default function Supplier() {
  return /*#__PURE__*/React.createElement(GuideLayout, {
    title: "\u4F9B\u5E94\u5546\u64CD\u4F5C\u6307\u5357",
    firstQuestion: "\u6211\u662F\u4F9B\u5E94\u5546\uFF0C\u767B\u5F55\u7CFB\u7EDF\u540E\u8BE5\u5E72\u4EC0\u4E48\uFF1F",
    sections: sections
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "full-flow"
  }, /*#__PURE__*/React.createElement("h2", null, "\u4F9B\u5E94\u5546\u5168\u6D41\u7A0B"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: fullFlowChart
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "tips"
  }, /*#__PURE__*/React.createElement("h2", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: tipsColumns,
    data: tipsData,
    pagination: false,
    size: "default",
    border: true
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "finance"
  }, /*#__PURE__*/React.createElement("h2", null, "\u5BF9\u8D26\u4E0E\u6536\u6B3E"), /*#__PURE__*/React.createElement("blockquote", null, "\u91C7\u8D2D\u65B9\u6536\u8D27\u5165\u5E93\u540E\uFF0C\u7CFB\u7EDF\u81EA\u52A8\u751F\u6210\u5BF9\u8D26\u5355\u3002\u4F60\u786E\u8BA4\u5BF9\u8D26\u5355\u540E\uFF0C\u7CFB\u7EDF\u6D3E\u751F\u4ED8\u6B3E\u5355\uFF0C\u91C7\u8D2D\u65B9\u5BA1\u6279\u901A\u8FC7\u540E\u4ED8\u6B3E\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u6536\u6B3E\u6D41\u7A0B"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: financeFlowChart
  })), /*#__PURE__*/React.createElement("h3", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u53CA\u65F6\u786E\u8BA4\u5BF9\u8D26\u5355"), "\u2014\u2014\u6838\u5BF9\u6536\u8D27\u6570\u91CF\u3001\u5355\u4EF7\u3001\u91D1\u989D\u662F\u5426\u4E0E\u5B9E\u9645\u4E00\u81F4\uFF0C\u6709\u5DEE\u5F02\u53CA\u65F6\u6C9F\u901A"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u5173\u6CE8\u4ED8\u6B3E\u5355\u72B6\u6001"), "\u2014\u2014\u5BF9\u8D26\u786E\u8BA4\u540E\u7CFB\u7EDF\u81EA\u52A8\u6D3E\u751F\u4ED8\u6B3E\u5355\uFF0C\u4F60\u53EF\u4EE5\u770B\u5230\u5BA1\u6279\u8FDB\u5EA6"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u6838\u5BF9\u4F59\u989D"), "\u2014\u2014\u5728\u4F9B\u5E94\u5546\u4F59\u989D\u8868\u4E2D\u67E5\u770B\u671F\u521D\u5E94\u4ED8\u3001\u672C\u671F\u4ED8\u6B3E\u3001\u671F\u672B\u5E94\u4ED8\u7B49\u660E\u7EC6"))), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-section'],
    id: "expense"
  }, /*#__PURE__*/React.createElement("h2", null, "\u8D39\u7528\u9879"), /*#__PURE__*/React.createElement("blockquote", null, "\u8D39\u7528\u662F\u7528\u6765\u5904\u7406\u91C7\u8D2D\u8BA2\u5355\u4E4B\u5916\u3001\u4F46\u4E0E\u53D1\u8D27/\u9000\u8D27\u76F8\u5173\u7684\u989D\u5916\u6536\u652F\u3002\u91D1\u989D\u53EF\u6B63\u53EF\u8D1F\uFF0C\u786E\u8BA4\u540E\u7EB3\u5165\u5BF9\u8D26\u5355\u4E00\u8D77\u7ED3\u7B97\u3002"), /*#__PURE__*/React.createElement("h3", null, "\u8D39\u7528\u6D41\u7A0B"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-chart']
  }, /*#__PURE__*/React.createElement(MermaidChart, {
    chart: expenseFlowChart
  })), /*#__PURE__*/React.createElement("h3", null, "\u5178\u578B\u573A\u666F"), /*#__PURE__*/React.createElement("div", {
    className: styles['guide-table']
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: expenseExamplesColumns,
    data: expenseExamplesData,
    pagination: false,
    size: "default",
    border: true
  })), /*#__PURE__*/React.createElement("h3", null, "\u64CD\u4F5C\u8981\u70B9"), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u53CA\u65F6\u786E\u8BA4\u8D39\u7528"), "\u2014\u2014\u91C7\u8D2D\u65B9\u53D1\u8D77\u7684\u8D39\u7528\uFF08\u5982\u7F5A\u6B3E\uFF09\u4F1A\u76F4\u63A5\u5F71\u54CD\u4F60\u7684\u6536\u6B3E\u91D1\u989D\uFF0C\u8981\u53CA\u65F6\u67E5\u770B"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u4E3B\u52A8\u521B\u5EFA\u8D39\u7528"), "\u2014\u2014\u5982\u6709\u989D\u5916\u8FD0\u8D39\u3001\u52A0\u6025\u8D39\u7B49\uFF0C\u4E3B\u52A8\u521B\u5EFA\u8D39\u7528\u9879\u5173\u8054\u5230\u5BF9\u5E94\u53D1\u8D27/\u9000\u8D27\u5355"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u8D39\u7528\u786E\u8BA4\u540E\u4E0D\u53EF\u4FEE\u6539"), "\u2014\u2014\u672A\u786E\u8BA4\u524D\u53EF\u5220\u9664\uFF0C\u786E\u8BA4\u540E\u7EB3\u5165\u5BF9\u8D26\u5355\u4E0D\u53EF\u64A4\u56DE"), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("strong", null, "\u5BF9\u8D26\u91D1\u989D = \u6536\u8D27/\u9000\u8D27 + \u5DF2\u786E\u8BA4\u8D39\u7528"), "\u2014\u2014\u8D39\u7528\u4F1A\u5408\u5E76\u5230\u5BF9\u8D26\u5355\u4E00\u8D77\u7ED3\u7B97"))));
}